import React from "react";
import {
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { createRole } from "../../../store/slices/usersSlice";

const CreateRoleModal = ({ isOpen, toggle }) => {
  const dispatch = useDispatch();
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      role_key: "",
      description: "",
    },
  });

  const createRoleFunc = (data) => {
    const payload = {
      role_key: data.role_key,
      role_value: data.role_key.toLowerCase().replace(/\s+/g, "-"),
      // description: data.description,
    };
    console.log("Payload:", payload);
    dispatch(createRole(payload)).then((res) => {
      console.log(res,"RESSSSS");
      
      if (res.type === "usersData/createRole/fulfilled") {
        console.log("Role created successfully:", res.payload);
        toggle();
      } else {
        console.error("Failed to create role:", res.payload);
      }
    });
  };

  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader>Create Role</ModalHeader>
        <ModalBody>
          <div className="px-2">
            <div>
              <Label>Role Name<span className="text-danger">*</span></Label>
              <Controller
                name="role_key"
                control={control}
                rules={{ required: "This field is required" }}
                render={({ field }) => (
                  <Input
                    {...field}
                    type="text"
                    placeholder="Enter role name"
                    required
                  />
                )}
              />
              {errors.role_key && (
                <span className="mt-1 text-danger">
                  {errors.role_key.message}
                </span>
              )}
            </div>
            <div className="mt-4">
              <Label>Role Description<span className="text-danger">*</span></Label>
              <Controller
                name="description"
                control={control}
                rules={{ required: "Description is required" }}
                render={({ field }) => (
                  <Input
                    {...field}
                    type="textarea"
                    placeholder="Enter role description"
                    required
                  />
                )}
              />
              {errors.description && (
                <span className="mt-1 text-danger">
                  {errors.description.message}
                </span>
              )}
            </div>
          </div>
        </ModalBody>
        <ModalFooter className="d-flex customModalFooter">
          <button className="btn bg-primary" onClick={handleSubmit(createRoleFunc)}>
            Create
          </button>
           <button className="btn bg-primary" onClick={toggle}>
            Cancel
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default CreateRoleModal;